import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// StrictMode disabled to prevent WebSocket connection issues
// StrictMode intentionally double-mounts components in development,
// which causes WebSocket cleanup/reconnect cycles in OBS pages
createRoot(document.getElementById('root')!).render(
  <App />
)
